import React from 'react'
import { useMedia } from 'sb-hooks'

import Center from 'components/layout/Center/Center'

import s from './ModalContainer.scss'


const ModalContainer = ({ children }) => {
  const { isMobile } = useMedia()

  return isMobile ? (
    <div className={s.modalContainer}>
      {children}
    </div>
  ) : (
    <Center className={s.modalContainer} scrollable>
      {children}
    </Center>
  )
}


export default ModalContainer
